/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Event_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Insert new event" |
*
* @param {Add_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const add_event_aria_label = /** @type {((inputs?: Add_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer un nouvel evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Ereignis einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci nuovo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить новое событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar nuevo evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入新事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいイベントを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया इवेंट डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir novo evento")
	return /** @type {LocalizedString} */ ("Insert new event")
});